export default __webpack_public_path__ + "static/media/limas.6ada5200.jpg";